module.exports = Object.assign({}, {
  defaultMapStyle: 'mapbox://styles/mapbox/light-v10',
});
